import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { getLevel, setLevel } from '../utils/level';

function Navbar() {
    const handleLevelChange = (event, newLevel) => {
        if (newLevel !== null && newLevel !== getLevel()) {
            setLevel(newLevel);
            // Retour à la racine pour repartir d'un état propre (pas d'édition à cheval sur 2 niveaux).
            // Rechargement complet REQUIS (pas de navigate()) : le toggle et les données
            // dépendent d'un remount intégral qui relit le level depuis localStorage.
            window.location.href = '/';
        }
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <FitnessCenterIcon sx={{ mr: 2 }} />
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    Protobe
                </Typography>
                <ToggleButtonGroup
                    value={getLevel()}
                    exclusive
                    onChange={handleLevelChange}
                    size="small"
                    sx={{ mr: 2, bgcolor: 'rgba(255,255,255,0.15)' }}
                >
                    <ToggleButton value={1} sx={{ color: 'white', '&.Mui-selected': { color: 'white', bgcolor: 'rgba(255,255,255,0.35)' } }}>
                        Niveau 1
                    </ToggleButton>
                    <ToggleButton value={2} sx={{ color: 'white', '&.Mui-selected': { color: 'white', bgcolor: 'rgba(255,255,255,0.35)' } }}>
                        Niveau 2
                    </ToggleButton>
                </ToggleButtonGroup>
                <Button color="inherit" component={RouterLink} to="/">
                    Sessions
                </Button>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;
